import axios from "axios";

export default {
    name: "bidBondRequest",
    state: {
        list: Array,
        bank: Array,
        manifest: Array,
        dataDtlForm: [],
        dataInfoForm: [],
    },
    getters: {
        getListBidBondRequest: state => {
            return state.list
        },
        getListnoBidBondRequest: state => {
            return state.list
        },
        getListBankBidBondRequest: state => {
            return state.bank
        },
        getManifestBidBondRequest: (state) => {
            return state.manifest
        },
        getDataDtlForm: state => {
            return state.dataDtlForm
        },
    },
    mutations: {
        setListBidBondRequest: (state, payload) => {
            state.list = payload
        },
        setListnoBidBondRequest: (state, payload) => {
            state.list = payload
        },
        setListBankBidBondRequest: (state, payload) => {
            state.bank = payload
        },
        setManifestBidBondRequest: (state, payload) => {
            state.manifest = payload
        },
        setDataInfoForm: (state, payload) => {
            state.dataInfoForm = payload
        },
        setDataDtlForm: (state, payload) => {
            state.dataDtlForm = [...state.dataDtlForm, { ...payload, id_dtl: payload.id_dtl ? payload.id_dtl : payload.id }]
        },
        setAllDataDtlForm: (state, payload) => {
            state.dataDtlForm = payload
        },
        editDataDtlForm: (state, payload) => {
            const source = [...state.dataDtlForm];
            const find = source.findIndex((item) => item.id_dtl === payload.id_dtl);

            if (find >= 0) {
                source[find] = payload
                state.dataDtlForm = source
            }
        },
        removeDataDtlForm: (state, payload) => {
            const source = [...state.dataDtlForm];
            const index = source.findIndex((data) => data === payload);

            source.splice(index, 1);
            state.dataDtlForm = source
        },
        clearDataForm: (state) => {
            state.dataDtlForm = [];
            state.dataDtlForm = [];
        },
    },
    actions: {
        getListBankBidBondRequest(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "main/bank_account",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setListBankBidBondRequest", response.data.bank_account);
                        resolve(response.data.bank_account);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getListnoBidBondRequest(store, { auth, type }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "bidbond/bidbond_request",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username,
                        type: type,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setListnoBidBondRequest", response.data.guarantee_fund);
                        resolve(response.data.guarantee_fund);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getListBidBondRequest(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "bidbond_request",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username,
                        type: 1,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setListBidBondRequest", response.data.data);
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitBidBondRequest(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "bidbond_request",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getManifestBidBondRequest(store, { auth,id }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "bidbond_request",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username,
                        bidbond_request_id: id
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setManifestBidBondRequest", response.data);
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        approvalManifestbidBondRequest(store, { auth, payload }) {
            console.log(auth,payload)
            return new Promise((resolve, reject) => {
              axios({
                method: "post",
                url: process.env.VUE_APP_SERVICEURL + "bidbond_request/approval",
                data: payload,
                auth: {
                  username: auth.username,
                  password: auth.password,
                },
                headers: {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": "multipart/form-data",
                },
              })
                .then(({ data, status }) => {
                  resolve(data);
                })
                .catch((err) => {
                  reject(err);
                });
            });
          },
          uploadDocbidbondReq(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                method: "post",
                url: process.env.VUE_APP_SERVICEURL + "bidbond_request/upload_bukti_transfer",
                data: payload,
                auth: {
                    username: auth.username,
                    password: auth.password,
                },
                headers: {
                    "X-API-KEY": auth.apikey,
                    "Content-Type": "multipart/form-data",
                },
                })
                .then(({ data, status }) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
        getRevbidbondReq(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                method: "get",
                url: process.env.VUE_APP_SERVICEURL + "bidbond_request/revisi",
                params: {id_manifest : payload},
                auth: {
                    username: auth.username,
                    password: auth.password,
                },
                headers: {
                    "X-API-KEY": auth.apikey,
                    "Content-Type": "application/json",
                },
                })
                .then(({ data, status }) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
        postRevbidbondReq(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                method: "post",
                url: process.env.VUE_APP_SERVICEURL + "bidbond_request/revisi",
                data: payload,
                auth: {
                    username: auth.username,
                    password: auth.password,
                },
                headers: {
                    "X-API-KEY": auth.apikey,
                    "Content-Type": "application/json",
                },
                })
                .then(({ data, status }) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
        getapprovalbidbondReq(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                method: "get",
                url: process.env.VUE_APP_SERVICEURL + "bidbond_request/approval",
                params: payload,
                auth: {
                    username: auth.username,
                    password: auth.password,
                },
                headers: {
                    "X-API-KEY": auth.apikey,
                    "Content-Type": "application/json",
                },
                })
                .then(({ data, status }) => {
                    resolve(data);
                })
                .catch((err) => {
                    reject(err);
                });
            });
        },
    },
};
